module.exports = __webpack_public_path__ + "static/media/alienDefence.3f13c1ae.png";